import styles from "./PageNotFound.module.css";
// Caso use React Router, você pode substituir a tag <a> pelo <Link to="/"> do react-router-dom

function PageNotFound() {
    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <h1 className={styles.errorCode}>404</h1>
                <h2 className={styles.title}>Página Não Encontrada</h2>
                <p className={styles.description}>
                    Ops! A página que você está procurando não existe, foi removida ou o link está quebrado.
                </p>
                <a href="/" className={styles.button}>
                    Voltar para a Home
                </a>
            </div>
        </div>
    );
}

export default PageNotFound;